module.exports = [{"value":"admin","text":"PDB Admin"},{"value":"pdb_agent","text":"PDB Agent"},{"value":"hq","text":"PDB Agent Company"},{"value":"petco_admin","text":"PETCO Admin"},{"value":"pli_admin","text":"PLI Admin"},{"value":"pcg_admin","text":"PCG Admin"},{"value":"petco_surveyor","text":"Surveyor"}]


//////////////////
// WEBPACK FOOTER
// ./src/Controls/Select/DataAccessCategory.json
// module id = 835
// module chunks = 21